import React from 'react';
import { Link } from 'react-router-dom';
import './LegalPages.css';

const Terms = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <Link to="/" className="back-link">← Back to Home</Link>
        
        <h1>Terms of Service</h1>
        <p className="last-updated">Last Updated: March 1, 2026</p>

        <section>
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing and using KwikLuv ("the Service"), you accept and agree to be bound by the terms 
            and provision of this agreement. If you do not agree to these Terms of Service, please do not 
            use the Service.
          </p>
        </section>

        <section>
          <h2>2. Eligibility</h2>
          <p>You must be at least 18 years old to use this Service. By using the Service, you represent and warrant that:</p>
          <ul>
            <li>You are at least 18 years of age</li>
            <li>You have the legal capacity to enter into these Terms</li>
            <li>You will comply with these Terms and all applicable laws</li>
            <li>You have never been convicted of a felony or sex crime</li>
          </ul>
        </section>

        <section>
          <h2>3. Account Registration</h2>
          <p>To use certain features of the Service, you must register for an account. You agree to:</p>
          <ul>
            <li>Provide accurate, current, and complete information</li>
            <li>Maintain and update your information to keep it accurate</li>
            <li>Maintain the security of your password</li>
            <li>Accept responsibility for all activities under your account</li>
            <li>Notify us immediately of any unauthorized use</li>
          </ul>
        </section>

        <section>
          <h2>4. User Conduct</h2>
          <p>You agree NOT to:</p>
          <ul>
            <li>Post false, inaccurate, misleading, or defamatory content</li>
            <li>Impersonate any person or entity</li>
            <li>Harass, abuse, threaten, or harm another person</li>
            <li>Use the Service for any illegal purpose</li>
            <li>Transmit any viruses, malware, or harmful code</li>
            <li>Scrape, copy, or use automated systems to access the Service</li>
            <li>Solicit money or engage in commercial activities without permission</li>
            <li>Post content involving minors</li>
            <li>Share explicit content without consent</li>
            <li>Create fake profiles or use stolen photos</li>
            <li>Send spam or unsolicited promotional messages</li>
            <li>Attempt to scam or defraud other users</li>
            <li>Circumvent or manipulate our payment systems</li>
          </ul>
          <p>
            Violations may result in account suspension or termination. Serious violations may be 
            reported to law enforcement.
          </p>
        </section>

        <section>
          <h2>5. Content</h2>
          <h3>Your Content</h3>
          <p>
            You retain ownership of content you post. By posting content, you grant us a worldwide, 
            non-exclusive, royalty-free license to use, reproduce, modify, and display your content 
            in connection with the Service.
          </p>
          <h3>Prohibited Content</h3>
          <p>You may not post content that:</p>
          <ul>
            <li>Is illegal, harmful, or offensive</li>
            <li>Infringes on intellectual property rights</li>
            <li>Contains nudity or sexual content (except in designated private areas)</li>
            <li>Promotes violence, discrimination, or hate speech</li>
            <li>Contains personal information of others without consent</li>
          </ul>
        </section>

        <section>
          <h2>6. Payments & Subscriptions</h2>
          <p>
            Certain features require payment. By purchasing credits or subscriptions, you agree to pay 
            all fees and charges. All sales are final and non-refundable unless required by law.
          </p>
          
          <h3>Credits System</h3>
          <ul>
            <li>Men receive 3 free messages upon registration</li>
            <li>Additional messages require credits (1 credit = 1 message)</li>
            <li>Credits can be purchased in packages (e.g., 10 credits for R10)</li>
            <li>Credits never expire and remain in your account</li>
            <li>Credits are non-transferable and non-refundable</li>
          </ul>

          <h3>Creator Subscriptions</h3>
          <ul>
            <li>Female creators can offer exclusive content to subscribers</li>
            <li>Subscription prices are set by individual creators</li>
            <li>Subscriptions are billed monthly and auto-renew</li>
            <li>You can cancel anytime; access continues until end of billing period</li>
            <li>No refunds for partial months or unused subscription time</li>
            <li>Creators may change subscription prices with 30 days notice</li>
            <li>Subscriber content is for personal use only; sharing is prohibited</li>
          </ul>

          <h3>Private Photo Unlocks</h3>
          <ul>
            <li>Some photos require credits to unlock (one-time payment)</li>
            <li>Once unlocked, you have permanent access to that photo</li>
            <li>Unlocks are non-refundable</li>
          </ul>

          <h3>Payment Processing</h3>
          <p>
            We use secure third-party payment processors (PayPal, Stripe). We do not store your 
            payment card details. All transactions are encrypted and secure.
          </p>
        </section>

        <section>
          <h2>7. Creator Content & Responsibilities</h2>
          <h3>For Creators</h3>
          <p>If you offer subscription content, you agree to:</p>
          <ul>
            <li>Post only content you own or have rights to</li>
            <li>Not post illegal, harmful, or prohibited content</li>
            <li>Respect subscriber privacy and not share their information</li>
            <li>Provide value to subscribers through regular content updates</li>
            <li>Comply with all applicable laws regarding adult content</li>
            <li>Pay applicable taxes on earnings</li>
          </ul>

          <h3>For Subscribers</h3>
          <p>If you subscribe to creator content, you agree to:</p>
          <ul>
            <li>Use content for personal viewing only</li>
            <li>Not download, record, screenshot, or share creator content</li>
            <li>Not harass or abuse creators</li>
            <li>Respect creator boundaries and content policies</li>
          </ul>

          <h3>Content Removal</h3>
          <p>
            We reserve the right to remove any content that violates these Terms or applicable laws. 
            Creators may lose their creator status for repeated violations.
          </p>
        </section>

        <section>
          <h2>8. Reporting & Moderation</h2>
          <h3>Report System</h3>
          <p>
            Users can report violations using the ⚠️ Report button on profiles. Reports are reviewed 
            within 24 hours. You can report:
          </p>
          <ul>
            <li>Harassment or abusive behavior</li>
            <li>Fake profiles or impersonation</li>
            <li>Inappropriate or illegal content</li>
            <li>Spam or commercial solicitation</li>
            <li>Scams or fraudulent activity</li>
            <li>Other violations of these Terms</li>
          </ul>

          <h3>Consequences</h3>
          <p>Depending on the severity of the violation, we may:</p>
          <ul>
            <li>Issue a warning</li>
            <li>Temporarily suspend your account</li>
            <li>Permanently ban your account</li>
            <li>Report illegal activity to law enforcement</li>
            <li>Take legal action for damages</li>
          </ul>

          <h3>False Reports</h3>
          <p>
            Submitting false or malicious reports is a violation of these Terms and may result in 
            account suspension.
          </p>
        </section>

        <section>
          <h2>9. Verification Badge</h2>
          <p>
            Users may request a verification badge through our video call verification process. 
            An admin will initiate a video call where you'll be asked to show a simple hand gesture 
            to confirm you're a real person. Verification is at our sole discretion and may be revoked at any time.
          </p>
          <ul>
            <li>You must answer the verification video call when contacted by an admin</li>
            <li>You can hide your face during the call; only a hand gesture is required</li>
            <li>Verification does not guarantee authenticity or endorse the user</li>
            <li>Verification may be revoked for Terms violations</li>
            <li>We reserve the right to deny verification without explanation</li>
            <li>Video calls are private and not recorded</li>
            <li>Missing multiple verification calls may result in request denial</li>
          </ul>
        </section>

        <section>
          <h2>10. Privacy</h2>
          <p>
            Your privacy is important to us. Please review our <Link to="/privacy">Privacy Policy</Link> to 
            understand how we collect, use, and protect your information.
          </p>
          <p>Key privacy points:</p>
          <ul>
            <li>We never sell your personal information</li>
            <li>Payment details are handled by secure third-party processors</li>
            <li>You control who sees your profile and photos</li>
            <li>You can delete your account and data at any time</li>
            <li>We use encryption to protect your data</li>
          </ul>
        </section>

        <section>
          <h2>11. Termination</h2>
          <p>
            We reserve the right to suspend or terminate your account at any time, with or without notice, 
            for any reason, including violation of these Terms. Upon termination:
          </p>
          <ul>
            <li>Your right to use the Service will immediately cease</li>
            <li>We may delete your account and content</li>
            <li>You will not be entitled to any refund of unused credits or subscriptions</li>
            <li>You must cease all use of any creator content you accessed</li>
            <li>Outstanding payments remain due</li>
          </ul>
          <p>
            You may delete your account at any time through Profile Settings. Account deletion is 
            permanent and cannot be undone.
          </p>
        </section>

        <section>
          <h2>12. Disclaimers</h2>
          <p>
            THE SERVICE IS PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND. WE DO NOT WARRANT THAT:
          </p>
          <ul>
            <li>The Service will be uninterrupted or error-free</li>
            <li>Defects will be corrected</li>
            <li>The Service is free of viruses or harmful components</li>
            <li>Results from using the Service will be accurate or reliable</li>
            <li>User profiles are authentic or accurate</li>
            <li>You will meet compatible people or achieve desired results</li>
          </ul>
          <p>
            We are not responsible for user conduct, content, or interactions. You use the Service 
            at your own risk.
          </p>
        </section>

        <section>
          <h2>13. Limitation of Liability</h2>
          <p>
            TO THE MAXIMUM EXTENT PERMITTED BY LAW, WE SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, 
            SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES, WHETHER 
            INCURRED DIRECTLY OR INDIRECTLY, OR ANY LOSS OF DATA, USE, GOODWILL, OR OTHER INTANGIBLE 
            LOSSES RESULTING FROM:
          </p>
          <ul>
            <li>Your use or inability to use the Service</li>
            <li>Unauthorized access to your account or data</li>
            <li>Conduct or content of other users</li>
            <li>Any content obtained from the Service</li>
          </ul>
        </section>

        <section>
          <h2>14. Indemnification</h2>
          <p>
            You agree to indemnify and hold us harmless from any claims, damages, losses, liabilities, 
            and expenses (including legal fees) arising from:
          </p>
          <ul>
            <li>Your use of the Service</li>
            <li>Your violation of these Terms</li>
            <li>Your violation of any rights of another person</li>
            <li>Content you post or share</li>
          </ul>
        </section>

        <section>
          <h2>15. Changes to Terms</h2>
          <p>
            We reserve the right to modify these Terms at any time. We will notify users of material 
            changes via email or through the Service. Continued use after changes constitutes acceptance 
            of the new Terms.
          </p>
          <p>
            It is your responsibility to review these Terms periodically. The "Last Updated" date at 
            the top indicates when changes were made.
          </p>
        </section>

        <section>
          <h2>16. Governing Law & Disputes</h2>
          <p>
            These Terms shall be governed by and construed in accordance with the laws of South Africa, 
            without regard to its conflict of law provisions.
          </p>
          <p>
            Any disputes arising from these Terms or the Service shall be resolved through binding 
            arbitration in South Africa, except where prohibited by law.
          </p>
        </section>

        <section>
          <h2>17. Severability</h2>
          <p>
            If any provision of these Terms is found to be unenforceable or invalid, that provision 
            shall be limited or eliminated to the minimum extent necessary, and the remaining provisions 
            shall remain in full force and effect.
          </p>
        </section>

        <section>
          <h2>18. Contact Us</h2>
          <p>If you have questions about these Terms, please contact us:</p>
          <ul>
            <li>Email: <a href="mailto:legal@kwikluv.com">legal@kwikluv.com</a></li>
            <li>Support: <Link to="/contact">Contact Form</Link></li>
            <li>Address: KwikLuv, South Africa</li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default Terms;
